import { render, staticRenderFns } from "./AppraisalSummary.vue?vue&type=template&id=2fb9f771"
import script from "./AppraisalSummary.vue?vue&type=script&lang=js"
export * from "./AppraisalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports